import React from 'react';

const FEATURED_KEYS = ['미뇨끼', '한신희', '유지만 yuziman', '1분요리 뚝딱이형', '자취요리신 simple cooking', '김밀란'];

export default function PaywallModal({ darkMode, isLoggedIn, onLogin, onSubscribe, channelProfiles }) {
  const avatars = FEATURED_KEYS.map(k => channelProfiles?.[k]).filter(Boolean).slice(0, 5);

  const bg = darkMode ? '#1c1c1e' : '#ffffff';
  const fg = darkMode ? '#f5f5f7' : '#1d1d1f';
  const sub = darkMode ? 'rgba(245,245,247,0.5)' : 'rgba(0,0,0,0.45)';

  return (
    <div style={{
      position: 'absolute', bottom: 0, left: 0, right: 0,
      background: bg, color: fg,
      borderRadius: '20px 20px 0 0',
      padding: '28px 24px 36px',
      boxShadow: '0 -4px 32px rgba(0,0,0,0.18)',
      zIndex: 100,
      textAlign: 'center',
    }}>
      {/* drag handle */}
      <div style={{
        width: 36, height: 4, borderRadius: 2,
        background: darkMode ? '#444' : '#ddd',
        margin: '0 auto 20px',
      }} />

      {/* avatars */}
      {avatars.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
          {avatars.map((src, i) => (
            <img key={i} src={src} alt="" style={{
              width: 38, height: 38, borderRadius: '50%',
              border: `2.5px solid ${bg}`,
              marginLeft: i === 0 ? 0 : -12,
              objectFit: 'cover',
              boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
            }} onError={e => { e.target.style.display = 'none'; }} />
          ))}
        </div>
      )}

      <h3 style={{ margin: '0 0 6px', fontSize: 22, fontWeight: 800, letterSpacing: -0.5 }}>
        +1,200개 레시피 보기
      </h3>
      <p style={{ margin: '0 0 22px', fontSize: 12, color: sub }}>
        월 4,900원 · 언제든 취소/해지 가능
      </p>

      <button
        onClick={isLoggedIn ? onSubscribe : onLogin}
        style={{
          width: '100%', padding: '15px', borderRadius: 14, border: 'none',
          background: isLoggedIn ? '#3182f6' : '#FEE500',
          color: isLoggedIn ? '#fff' : '#191919',
          fontSize: 15, fontWeight: 700,
          cursor: 'pointer', marginBottom: 12,
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          boxShadow: isLoggedIn ? '0 4px 16px rgba(49,130,246,0.35)' : '0 4px 16px rgba(254,229,0,0.4)',
        }}
      >
        {!isLoggedIn && (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <circle cx="9" cy="9" r="9" fill="#191919" fillOpacity=".07"/>
            <path d="M9 4.5C6.515 4.5 4.5 6.432 4.5 8.82c0 1.575.864 2.97 2.16 3.87v1.56l1.476-.822c.276.075.567.117.864.117 2.484 0 4.5-1.932 4.5-4.32C13.5 6.432 11.484 4.5 9 4.5z" fill="#191919"/>
          </svg>
        )}
        {isLoggedIn ? '무료로 계속 보기' : '7일 무료 체험'}
      </button>

    </div>
  );
}
